module.exports = __webpack_public_path__ + "img/residence.cb4e8ab5.svg";